"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WAI_ARIA_ATTRIBUTE = exports.DEFAULT_COLOR = void 0;
exports.DEFAULT_COLOR = '#4fa94d';
exports.DEFAULT_WAI_ARIA_ATTRIBUTE = {
    'aria-busy': true,
    role: 'status',
};
